var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "my-el-header" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c(
              "el-row",
              { attrs: { type: "flex" } },
              [
                _c("el-col", { staticClass: "jzq-logo", attrs: { span: 3 } }, [
                  _c("img", {
                    attrs: { src: "/images/logo/jzq-logo.png", alt: "" }
                  })
                ]),
                _c("el-col", { attrs: { span: 15 } }, [
                  _c("nav", [
                    _c("ul", [
                      _c("li", { staticClass: "active" }, [
                        _c("span", { staticClass: "item" }, [_vm._v("首页")])
                      ]),
                      _c("li", [
                        _c("span", { staticClass: "item" }, [
                          _vm._v("文件管理")
                        ])
                      ]),
                      _c("li", { staticStyle: { cursor: "pointer" } }, [
                        _c("div", { staticClass: "item" }, [_vm._v("司法服务")])
                      ])
                    ])
                  ])
                ]),
                _c("el-col", {
                  staticStyle: {
                    "padding-left": "20px",
                    "box-sizing": "border-box"
                  },
                  attrs: { span: 6 }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("el-main", [_c("nuxt")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d317f22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d317f22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/defaultStatc.vue
// module id = 5IuO
// module chunks = 159